<template>
    <div class="content-center none-click">
      <div class="banner">
        <div class="banner_box">
            <div class="banner_title">千橙掌柜智慧门店</div>
            <div class="banner_line"></div>
            <div class="banner_title2" style="width:114px;">零售门店一站式数智化升级方案，帮助零售行业从采、管、销多维度全链路解决门店经营问题</div>
            <!-- <div class="banner_text">企业私域电商直播平台</div> -->
        </div>
        <img src="@/assets/Mobile/images/QcShopkeeper/banner.png" alt="">
      </div>
      <div class="programme programme1">
        <div class="sk-mobile-title">
          <div class="title">零售门店经营升级挑战</div>
          <div class="sub-title">消费市场的习惯与供需变化，对零售门店的经营增长呈现巨大压力</div>
        </div>
        <div class="content" style="margin-top: 10px;">
            <img style="margin-top: 3px;" src="@/assets/Mobile/images/QcShopkeeper/programme1.png" alt="">
            <img style="margin-top: 3px;"  src="@/assets/Mobile/images/QcShopkeeper/programme2.png" alt="">
            <img style="margin-top: 3px;"  src="@/assets/Mobile/images/QcShopkeeper/programme3.png" alt="">
        </div>
      </div>
      <div class="store">
        <div class="store_title">聚焦门店经营场景，实现线上线下经营闭环，帮老板实现线下店+线上店+社群店一店三开</div>
        <div class="store_banner">
            <img v-if="tooItem=='1'" src="@/assets/images/QcShopkeeper/item1.png" alt="">
            <img v-if="tooItem=='2'" src="@/assets/images/QcShopkeeper/item2.png" alt="">
            <img v-if="tooItem=='3'" src="@/assets/images/QcShopkeeper/item3.png" alt="">
            <img v-if="tooItem=='4'" src="@/assets/images/QcShopkeeper/item4.png" alt="">
            <img v-if="tooItem=='5'" src="@/assets/images/QcShopkeeper/item5.png" alt="">
            <img v-if="tooItem=='6'" src="@/assets/images/QcShopkeeper/item6.png" alt="">
            <img v-if="tooItem=='7'" src="@/assets/images/QcShopkeeper/item7.png" alt="">
            <img v-if="tooItem=='8'" src="@/assets/images/QcShopkeeper/item8.png" alt="">
            <img v-if="tooItem=='9'" src="@/assets/images/QcShopkeeper/item9.png" alt="">

        </div>
        <div class="store_box">
            <div :class="tooItem=='1'?'box_item1':'box_item'" @click="checkBg('1')">
                <img src="@/assets/images/QcShopkeeper/box1.png" alt="">
                <span>线上店</span>
            </div>
            <div :class="tooItem=='2'?'box_item1':'box_item'" @click="checkBg('2')">
                <img src="@/assets/images/QcShopkeeper/box2.png" alt="">
                <span>社群店</span>
            </div>
            <div :class="tooItem=='3'?'box_item1':'box_item'" @click="checkBg('3')">
                <img src="@/assets/images/QcShopkeeper/box3.png" alt="">
                <span>称重收银</span>
            </div>
            <div :class="tooItem=='4'?'box_item1':'box_item'" @click="checkBg('4')">
                <img src="@/assets/images/QcShopkeeper/box4.png" alt="">
                <span>进销存管理</span>
            </div>
            <div :class="tooItem=='5'?'box_item1':'box_item'" @click="checkBg('5')">
                <img src="@/assets/images/QcShopkeeper/box5.png" alt="">
                <span>经营分析</span>
            </div>
            <div :class="tooItem=='6'?'box_item1':'box_item'" @click="checkBg('6')">
                <img src="@/assets/images/QcShopkeeper/box6.png" alt="">
                <span>自助终端</span>
            </div>
            <div :class="tooItem=='7'?'box_item1':'box_item'" @click="checkBg('7')">
                <img src="@/assets/images/QcShopkeeper/box7.png" alt="">
                <span>便捷开单</span>
            </div>
            <div :class="tooItem=='8'?'box_item1':'box_item'" @click="checkBg('8')">
                <img src="@/assets/images/QcShopkeeper/box8.png" alt="">
                <span>智能巡店</span>
            </div>
            <div :class="tooItem=='9'?'box_item1':'box_item'" @click="checkBg('9')">
                <img src="@/assets/images/QcShopkeeper/box9.png" alt="">
                <span>智能货柜</span>
            </div>
        </div>
    </div>
    <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">零售门店经营升级挑战</div>
          <!-- <div class="sub-title">消费市场的习惯与供需变化，对零售门店的经营增长呈现巨大压力</div> -->
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcShopkeeper/programme4.png" alt="">
        </div>
      </div>
      <div class="programme programme3">
        <div class="sk-mobile-title">
          <div class="title">支持层级区域管理，满足分公司、区域、加盟商多场景管理需求</div>
          <!-- <div class="sub-title">消费市场的习惯与供需变化，对零售门店的经营增长呈现巨大压力</div> -->
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcShopkeeper/programme5.png" alt="">
            <div class="content_btn">
                <div class="btn_box" @click="linkTo('QcChain')"></div>
            </div>
        </div>
      </div>
      <div class="programme">
        <div class="sk-mobile-title">
          <div class="title">专为智慧门店打造专属产品矩阵</div>
          <!-- <div class="sub-title">消费市场的习惯与供需变化，对零售门店的经营增长呈现巨大压力</div> -->
        </div>
        <div class="content">
            <img src="@/assets/Mobile/images/QcShopkeeper/programme6.png" alt="">
            <div class="content_btn1">
                <div class="btn_box">
                    <div class="box_item" @click="linkTo('QcErpSystem')"></div>
                </div>
                <div class="btn_box">
                    <div class="box_item" @click="linkTo('QcShoppingMall')"></div>
                </div>
                <div class="btn_box">
                    <div class="box_item" @click="linkTo('QcCashier')"></div>
                </div>
                <div class="btn_box">
                    <div class="box_item" @click="linkTo('QcChain')"></div>
                </div>
            </div>
        </div>
      </div>
      <div class="page_main1" style="margin-bottom: 29px;">
        <div class="sk-mobile-title">
          <div class="title">客户案例</div>
        </div>
        <div class="content" style="margin-top: 22px;">
            <img src="@/assets/Mobile/images/QcShopkeeper/case1.png" alt="">
        </div>
      </div>
      <Case title="微商城" />
      <ContactForm info-sources="千橙掌柜智慧门店" />
      <TryModal v-if="tryVisible" :visible="tryVisible" info-sources="千橙掌柜智慧门店" @cancel="modalClose" />
  
    </div>
  </template>
  
  <script>
  import metaInfo from '@/common/util/metaInfo'
  import ContactForm from '@/Mobile/Mobilecom/ContactForm'
  import Case from '@/Mobile/Mobilecom/Case'
  import TryModal from '@/Mobile/Mobilecom/TryModal'
  
  export default {
    metaInfo: metaInfo.QcShopkeeper,
    components: {
      ContactForm,
      Case,
      TryModal
    },
    data() {
      return {
        tryVisible: false,
        tooItem:'1',
      }
    },
    mounted() {
  
    },
    methods: {
      linkTo(path) {
          this.$router.push({ path: '/m/' + path })
          this.$nextTick(() => {
              this.open = false
          })
      },
      checkBg(item) {
        this.tooItem = item;
      },
      openModal: function() {
        this.tryVisible = true
      },
      modalClose: function(data) {
        this.tryVisible = data
      }
    }
  }
  </script>
  
  <style lang="less" scoped>
  .page_main1{
    background: rgba(234,243,255,.6);
    .content{
        padding: 0 16px;
        img{
            width: 100%;
            height:100%;
        }
    }
  }
  .store{
        background: #202239;
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items:center;
        .store_banner{
            margin-top:24px;
            img{
                height:137px; 
            }
        }
        .store_title{ 
            width:316px;
            height: 91px;
            font-size: 20px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 28px;
            margin-top:24px;
        }
        .store_box{
            margin-top:5px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: start;
            .box_item{
                width: 108px;
                height: 37px;
                background: linear-gradient(97deg, #1F223B 0%, #354361 100%);
                border-radius: 3px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                margin-left: 10px;
                margin-bottom: 10px;
                span{
                    height: 12px;
                    font-size: 9px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 12px;
                    margin-left: 10px;
                }
                img{
                    width: 18px;
                    height: 18px;
                }
            }
            .box_item1{
                width: 108px;
                height: 37px;
                background: linear-gradient(270deg, #6CB1FF 0%, #376CEA 100%);
                border-radius: 3px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                margin-left: 10px;
                margin-bottom: 10px;
                cursor: pointer;
                span{
                    height: 12px;
                    font-size: 9px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    line-height: 12px;
                    margin-left: 10px;
                }
                img{
                    width: 18px;
                    height: 18px;
                }
            }
        }
}

.content_btn{
    height:20px;
    position: absolute;
    bottom:0;
    .btn_box{
        width:60px;
        height:20px;
    }
}
.content_btn1{
    width:343px;
    height:471px;
    position: absolute;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .btn_box{
        width:170px;
        height:235px;
        position: relative;
        display: flex;
        flex-direction: row;
        justify-content: center;
        .box_item{
            width:110px;
            height:40px;
            position: absolute;
            bottom:0;
        }
    }
}
  .programme1{
    background: #FFFFFF;
  }
  .programme2{
    background: #F8FCFF;
  }
  .programme3{
    background: #F8FBFF;
  }
  .programme4{
    background: #F8FBFD;
  }
  .banner_box{
    position: absolute;
    top: 25px;
    left:16px;
    .banner_title{
        height: 25px;
        font-size: 18px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 25px;
        text-align: left;
    }
    .banner_title2{
        width: 142px;
        height: 28px;
        font-size: 10px;
        font-family: FZLTZHK--GBK1, FZLTZHK--GBK1;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 14px;
        margin-top: 22px;
        text-align: left
    }
    .banner_line{
        width: 50px;
        height: 3px;
        background: #28DAFB;
        margin-top:6px;
        
    }
    .banner_text{
        margin-top:22px;
        width: 134px;
        height: 78px;
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 17px;
        text-align: left
    }
  }
  .banner {
    width: 100%;
    height: 200px;
    margin-top: 50px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
 
  </style>
  